import { useSyncExternalStore } from 'react';

let coverageRefreshVersion = 0;
const listeners = new Set<() => void>();

const subscribe = (listener: () => void): (() => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

const getSnapshot = (): number => coverageRefreshVersion;

export const emitCoverageRefresh = (): void => {
  coverageRefreshVersion += 1;
  listeners.forEach((listener) => {
    listener();
  });
};

export const useCoverageRefreshVersion = (): number =>
  useSyncExternalStore(subscribe, getSnapshot, getSnapshot);

export const resetCoverageRefreshForTests = (): void => {
  coverageRefreshVersion = 0;
  listeners.forEach((listener) => {
    listener();
  });
};
